/**
 * Mounted once in the signed-in shell: fires a clock tap kept by
 * `clockViaSession` while the session was dead (see pendingClock.ts).
 */
import { useEffect, useRef } from 'react';
import { useFireAndForget } from '../components/BackgroundSubmit';
import { readPendingClock, replayPendingClock } from './pendingClock';

export function PendingClockReplay() {
  const fireAndForget = useFireAndForget();
  const done = useRef(false);
  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const p = readPendingClock();
    if (!p) return;
    fireAndForget(() => replayPendingClock(), { label: 'Saving your clock-in…', successLabel: 'Clock-in saved', confirm: true });
  }, [fireAndForget]);
  return null;
}
